import apiClient from '../client.js'

// Guests own their chats through this token (returned once when starting a chat)
export const CHAT_TOKEN_KEY = 'chat_guest_token'

const chatHeaders = () => {
  const token = localStorage.getItem(CHAT_TOKEN_KEY)
  return token ? { 'X-Chat-Token': token } : {}
}

export const chatAPI = {
  async start(payload) {
    const response = await apiClient.post('/chat/conversations', payload, { headers: chatHeaders() })
    return response.data
  },

  async list() {
    const response = await apiClient.get('/chat/conversations', { headers: chatHeaders() })
    return response.data
  },

  async get(uuid, after = 0) {
    const response = await apiClient.get(`/chat/conversations/${uuid}`, {
      params: after ? { after } : {},
      headers: chatHeaders(),
    })
    return response.data
  },

  async send(uuid, message, after = 0) {
    const response = await apiClient.post(`/chat/conversations/${uuid}/messages`, { message, after }, { headers: chatHeaders() })
    return response.data
  },

  async close(uuid, after = 0) {
    const response = await apiClient.post(`/chat/conversations/${uuid}/close`, { after }, { headers: chatHeaders() })
    return response.data
  },

  async transcript(uuid, email = null) {
    const response = await apiClient.post(`/chat/conversations/${uuid}/transcript`, email ? { email } : {}, { headers: chatHeaders() })
    return response.data
  },

  async unreadCount() {
    const response = await apiClient.get('/chat/unread-count', { headers: chatHeaders() })
    return response.data
  },

  async claim() {
    const response = await apiClient.post('/chat/claim', {}, { headers: chatHeaders() })
    return response.data
  },
}

export const adminChatAPI = {
  async list(params = {}) {
    const response = await apiClient.get('/admin/chat', { params })
    return response.data
  },

  async get(id, after = 0) {
    const response = await apiClient.get(`/admin/chat/${id}`, { params: after ? { after } : {} })
    return response.data
  },

  async send(id, message, after = 0) {
    const response = await apiClient.post(`/admin/chat/${id}/messages`, { message, after })
    return response.data
  },

  async close(id, after = 0) {
    const response = await apiClient.post(`/admin/chat/${id}/close`, { after })
    return response.data
  },

  async reopen(id, after = 0) {
    const response = await apiClient.post(`/admin/chat/${id}/reopen`, { after })
    return response.data
  },

  async unreadCount() {
    const response = await apiClient.get('/admin/chat/unread-count')
    return response.data
  },
}
